import type { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { FuscaFleetAddressRequest } from './fleet';

export enum TicketStatus {
  SCHEDULE_INSTALLATION = 'SCHEDULE_INSTALLATION',
  SEARCHING_TECHNICIAN = 'SEARCHING_TECHNICIAN',
  WAITING_FOR_INSTALLATION = 'WAITING_FOR_INSTALLATION',
  INSTALLATION_DONE = 'INSTALLATION_DONE',
  WAITING_FOR_RESPONSE = 'WAITING_FOR_RESPONSE',
  INSTALLATION_CANCELLED = 'INSTALLATION_CANCELLED',
  INSTALLATION_NOT_DONE = 'INSTALLATION_NOT_DONE',

  SHIPPING_REQUESTED = 'SHIPPING_REQUESTED',
  IN_PREPARATION = 'IN_PREPARATION',
  WAITING_FOR_SHIPMENT_COMPANY = 'WAITING_FOR_SHIPMENT_COMPANY',
  ON_THE_WAY = 'ON_THE_WAY',
  DELIVERED = 'DELIVERED',
  SHIPMENT_CANCELLED = 'SHIPMENT_CANCELLED',
  SHIPMENT_RETURNED = 'SHIPMENT_RETURNED',

  RETURN_REQUESTED = 'RETURN_REQUESTED',
  SCHEDULE_UNINSTALLATION = 'SCHEDULE_UNINSTALLATION',
  WAITING_FOR_UNINSTALLATION = 'WAITING_FOR_UNINSTALLATION',
  REQUEST_POSTAGE_CODE = 'REQUEST_POSTAGE_CODE',
  WAITING_FOR_RETURN = 'WAITING_FOR_RETURN',
  RETURN_DONE = 'RETURN_DONE',
  DEVICES_NOT_RETURNED = 'DEVICES_NOT_RETURNED',
  RETURN_CANCELLED = 'RETURN_CANCELLED',
  UNINSTALLATION_NOT_DONE = 'UNINSTALLATION_NOT_DONE',

  UNKNOWN = 'UNKNOWN',
}

export interface TicketDeviceRequest {
  problem: string; // subject
  message: string; // description
  deviceGeneralStatus?: DeviceGeneralStatus | string; // available, no_signal, etc
  address?: FuscaFleetAddressRequest; // optional address related to the ticket
  sourceType?: string; // optional source type related to the ticket
}
